import { LoaderFunction } from 'react-router-dom';
import { Bakery2bTabs } from '../states/tabState.model';
import { take } from 'rxjs';
import {
  bakery2bService,
  ListBakery2bQueryRes,
  GetBakery2bSettingsQueryRes,
  ListBakery2bStatisticQueryRes,
} from '../services/bakery2b.service.ts';
import { responseHandler } from '../../../../shared/responseHandler/responseHandler.ts';
import { bakery2bTabLoadingService } from '../bakery2bTabLoading.service.ts';
import { storageHelper } from '../../../../shared/helpers/storage';
import { dataHelper } from '../../../../shared/helpers/data/data.helper.ts';
import { initBakery2bClientsState } from '../states/bakery2bClients.state.ts';
import { initialBakery2bStatisticTabState } from '../states/bakery2bStatistic.state.ts';

export const bakery2bLoader: LoaderFunction = async ({ params }) => {
  const { tab } = params || {};
  if (!tab || !Object.values(Bakery2bTabs).includes(tab as Bakery2bTabs)) {
    location.href = '/404';
  }
  let tabState;

  switch (tab) {
    case Bakery2bTabs.settings: {
      const companySettings = await bakery2bService.globHelpers.streamToPromise(
        bakery2bService.sub.getBakery2bSettings().pipe(
          responseHandler<GetBakery2bSettingsQueryRes | null>({
            errorReturnType: null,
          }),
          take(1),
        ),
        () => bakery2bService.pub.getBakery2bSettings(),
      );

      tabState = {
        companySettings,
      };
      break;
    }
    case Bakery2bTabs.clients:
      let listBakery2bClient = await bakery2bService.globHelpers.streamToPromise(
        bakery2bService.sub.listBakery2bClient().pipe(
          responseHandler<ListBakery2bQueryRes>({
            errorReturnType: [],
          }),
          take(1),
        ),
        () => {
          bakery2bService.pub.listBakery2bClient();
        },
      );
      const listBakery2bClientSortModel =
        storageHelper.local.getItem('bakery2bClient.sortModel') ||
        initBakery2bClientsState.listBakery2bClientSortModel;
      if (listBakery2bClient.length) {
        listBakery2bClient = dataHelper
          .data(listBakery2bClient as [])
          .sort({ sortModel: listBakery2bClientSortModel })
          .result() as ListBakery2bQueryRes;
      }
      tabState = { clientsTab: { listBakery2bClient, listBakery2bClientSortModel } };
      break;
    case Bakery2bTabs.statistic: {
      let statisticList = await bakery2bService.globHelpers.streamToPromise(
        bakery2bService.sub.listBakery2bStatistic().pipe(
          responseHandler<ListBakery2bStatisticQueryRes>({
            errorReturnType: [],
          }),
          take(1),
        ),
        () => {
          bakery2bService.pub.listBakery2bStatistic({
            params: initialBakery2bStatisticTabState.dateRange,
          });
        },
      );
      const statisticListSortModel =
        storageHelper.local.getItem('bakery2bStatistic.sortModel') ||
        initialBakery2bStatisticTabState.statisticListSortModel;
      if (statisticList.length) {
        statisticList = dataHelper
          .data(statisticList as [])
          .sort({ sortModel: statisticListSortModel })
          .result() as ListBakery2bStatisticQueryRes;
      }
      tabState = { statisticTab: { statisticList, statisticListSortModel } };
      break;
    }
    default:
      tabState = {};
      break;
  }

  bakery2bTabLoadingService.pub.loading(false);

  return {
    ...tabState,
  };
};
